<template>
 <li class="item" >
   <!-- 列表标题 -->
   <div :class="{leaf:isLeaf, root:!isLeaf}" @click="handleClick">
      <span>{{(menuItem||{}).name}}</span>
      <span class="icon" :class={expand:isExpand} @click.stop="toggleExpand"></span>
   </div>
   <transition name="slide-fade">
      <div @click.stop v-if="isExpand">
         <slot name="sub" />
      </div>
   </transition>
 </li>
</template>

<script>
import {getURLWithContext, getDynamicURLWithContext, getDynamicURLWithContextNew} from '@/util/util'
import {mapMutations} from 'vuex'
export default {
   data () {
        return {
            isExpand: false,
        }
   },
   props: {
      menuItem: {
         type: Object
      }
   },
   computed: {
      isLeaf () {
         return !(this.menuItem || {}).children
      }
   },
   methods: {
      ...mapMutations(['setShowNav']),
      handleClick() {
         const path = (this.menuItem||{}).path
         if (path) {                                                    // 如果有path配置项则直接跳转
            this.setShowNav(false)
            const isLink = /^http/.test(path)
            if (isLink) {                                               // 如果后缀为.html，则为旧页面， 否则为路由
               window.top.location = path
            } else {
               const routePath = getDynamicURLWithContextNew(path)
               if (routePath === this.$route.fullPath) return 
               routePath && this.$router.push(routePath)
            }
         } else if (this.isLeaf) {                                      // 没有path配置项，且为叶子节点菜单项，则根据code跳转链接
            this.setShowNav(false)
            const code = (this.menuItem||{}).code
            if (code) {
               const routePath = getDynamicURLWithContextNew(`product/detail/${code}`)
               if (routePath === this.$route.fullPath) return 
               routePath && this.$router.push(routePath)
            }
         } else {
            this.toggleExpand()                                         // 没有path配置项， 有下级菜单，则展开
         }
      },
      toggleExpand () {
         this.isExpand ^= true;
      }
   }
}
</script>
<style lang="scss" scoped>
.item {
   .icon {
      display: inline-block;
      text-align: center;
      margin-right: .3rem;
      color: #666666;
      position: absolute;
      right: 0;
      width: .2rem;
      height: .2rem;
   }
}
.icon::before {
   content: '+';
   font-size: .5rem;
   line-height: 2;
}
.icon.expand::before {
   content: '-';
   font-size: .5rem;
   line-height: 2;
}
.leaf .icon::before {
   content: '';
   display: inline-block;
   width: .15rem;
   height: .15rem;
   border-top: solid .05rem #666;
   border-right: solid .05rem #666;
   transform: rotate(45deg);
}
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(.1rem);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/header/droplist/menu-item.vue